const config = {
  apiGateway: {
    REGION: 'ap-southeast-1',
    INTERNAL_API_URL: 'https://y3pjca023k.execute-api.ap-southeast-1.amazonaws.com/prod',
    TEAM_API_URL: 'https://hm117o49k0.execute-api.ap-southeast-1.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.oceanagold.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.oceanagold.forwoodsafety.com',
    WEBSOCKET: 'wss://rtlm1yf763.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
};

export default config;
